export * from '@primeuix/themes/aura/avatar';
export { default } from '@primeuix/themes/aura/avatar';
